const initSidebarNavHighlight = () => {
	const nav = document.querySelector('.sidebar-page-nav nav');
	if (!nav) return;

	const links = nav.querySelectorAll('a[href^="#"]');
	if (!links.length) return;

	const activeAdd = ['text-blue-dark', 'border-blue-medium'];
	const activeRemove = ['text-blue-medium', 'border-transparent'];

	const setActive = (id) => {
		links.forEach((link) => {
			const isActive = link.getAttribute('href') === `#${id}`;
			link.classList.toggle('border-blue-medium!', isActive);
		});
	};

	const sectionIds = Array.from(links).map((link) => link.getAttribute('href').slice(1));
	const sections = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);

	if (!sections.length) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) setActive(entry.target.id);
			});
		},
		{ rootMargin: '-20% 0px -60% 0px', threshold: 0 }
	);

	sections.forEach((section) => observer.observe(section));
};

export { initSidebarNavHighlight };
